import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import StudentRow from "../../components/StudentPortal/Leaderboard/StudentRow";
import { useGetAssignmentMarksQuery } from "../../features/assignment/assignmentApi";
import { useGetQuizMarksQuery } from "../../features/quiz/quizApi";
import { useGetStudentsQuery } from "../../features/users/usersApi";
import { getTopScorers } from "../../utils/getTopScorer";

const Leaderboard = () => {
  const { id: userId } = useSelector((state) => state.auth.user);
  const {
    data: quizMarks,
    isLoading: quizReqLoading,
    isError: quizReqError,
  } = useGetQuizMarksQuery();
  const {
    data: assignmentMarks,
    isLoading: assignmentsReqLoading,
    isError: assignmentsReqError,
  } = useGetAssignmentMarksQuery();
  const {
    data: students,
    isLoading: studentReqLoading,
    isError: studentReqError,
  } = useGetStudentsQuery();

  const markList = useMemo(() => {
    if (quizMarks && assignmentMarks && students) {
      return getTopScorers(assignmentMarks, quizMarks, students);
    }
    return undefined;
  }, [quizMarks, assignmentMarks, students]);

  const currentUserMarks = useMemo(() => {
    if (markList && markList.length > 0) {
      return markList.find((user) => user.id === userId);
    }
    return null;
  }, [markList, userId]);


  if (quizReqLoading || assignmentsReqLoading || studentReqLoading) {
    return <div>Loading...</div>;
  }
  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div>
          <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
          {currentUserMarks && (
            <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
              <thead>
                <tr>
                  <th className="table-th !text-center">Rank</th>
                  <th className="table-th !text-center">Name</th>
                  <th className="table-th !text-center">Quiz Mark</th>
                  <th className="table-th !text-center">Assignment Mark</th>
                  <th className="table-th !text-center">Total</th>
                </tr>
              </thead>

              <tbody>
                <tr className="border-2 border-cyan">
                  <td className="table-td text-center font-bold">
                    {currentUserMarks?.rank}
                  </td>
                  <td className="table-td text-center font-bold">
                    {currentUserMarks?.name}
                  </td>
                  <td className="table-td text-center font-bold">
                    {currentUserMarks?.totalQuizMark}
                  </td>
                  <td className="table-td text-center font-bold">
                    {currentUserMarks?.totalAssignmentMark}
                  </td>
                  <td className="table-td text-center font-bold">
                    {currentUserMarks?.totalMark}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="my-8">
          <h3 className="text-lg font-bold">Top 20 Result</h3>
          <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
            <thead>
              <tr className="border-b border-slate-600/50">
                <th className="table-th !text-center">Rank</th>
                <th className="table-th !text-center">Name</th>
                <th className="table-th !text-center">Quiz Mark</th>
                <th className="table-th !text-center">Assignment Mark</th>
                <th className="table-th !text-center">Total</th>
              </tr>
            </thead>

            <tbody>
              {markList &&
                markList.map((student) => (
                  <StudentRow key={student.id} student={student} />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Leaderboard;
